import React from 'react';
import { Button, Typography, ScreenContainer, ContentFrame, LayoutContent, LayoutControls, } from '@pinwheel/origami';
import ModalHeader from '../../components/ModalHeader';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import Divider from '../../components/Divider';
import DocumentUploadsCard from '../../components/DocumentUploads/DocumentUploadsCard';
import DocumentUploadsFileUploadButton from '../../components/DocumentUploads/DocumentUploadsFileUploadButton';
import { useAppSelector } from '../../state';
import { selectStagedDocuments } from '../../state/slices/slice-document-uploads';
import { DocumentUploadsStatus } from '../../types/document-uploads';
import { DOCUMENT_UPLOADS_SUBMIT_CACHE_KEY, useSubmitDocumentsMutation, } from '../../state/services/link-api';
import { generateLinkPath } from '../../Router/generateLinkPath';
var DocumentUploadsList = function () {
    var getLocalizedString = useGetLocalizedString();
    var navigate = useLinkNavigate();
    var stagedDocuments = useAppSelector(selectStagedDocuments);
    var additionalUploadEnabled = stagedDocuments.length < 5;
    var triggerSubmitDocuments = useSubmitDocumentsMutation({
        // Allows the request results to be shared across hook usages. We want to
        // trigger the request here, and then show the loading/completion status
        // in <DocumentUploadsSubmitted>.
        fixedCacheKey: DOCUMENT_UPLOADS_SUBMIT_CACHE_KEY,
    })[0];
    // Submittable if at least one document is uploaded and no documents are uploading
    var submittable = stagedDocuments.some(function (document) {
        return document.status === DocumentUploadsStatus.UPLOADED;
    }) &&
        !stagedDocuments.some(function (document) {
            return document.status === DocumentUploadsStatus.UPLOADING;
        });
    var onSubmit = function () {
        var preSignedUrlsToSubmit = stagedDocuments
            .filter(function (document) {
            return document.status === DocumentUploadsStatus.UPLOADED;
        })
            .map(function (document) { return document.preSignedUrl; });
        void triggerSubmitDocuments({ preSignedUrls: preSignedUrlsToSubmit });
        navigate('/document-uploads/submitted');
    };
    return (React.createElement(ScreenContainer, null,
        React.createElement(ModalHeader, null),
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, null,
                React.createElement("div", { style: {
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'column',
                    } },
                    React.createElement("div", null,
                        React.createElement(Typography, { align: "center", variant: "label", as: "h2" }, getLocalizedString('PAYSTUB_DOCUMENTS'))),
                    React.createElement(Divider, { style: { margin: '24px 0' } }),
                    stagedDocuments.map(function (_a) {
                        var id = _a.id, name = _a.name, status = _a.status;
                        return (React.createElement(DocumentUploadsCard, { key: id, fileName: name, uploadStatus: status, sx: { marginBottom: '8px' }, onRepair: function () {
                                return navigate(generateLinkPath('/document-uploads/repair/:fileId', {
                                    fileId: id,
                                }));
                            }, onDelete: function () {
                                return navigate(generateLinkPath('/document-uploads/delete/:fileId', {
                                    fileId: id,
                                }));
                            } }));
                    }))),
            React.createElement(LayoutControls, null,
                additionalUploadEnabled && (React.createElement(DocumentUploadsFileUploadButton, { "data-testid": "DocumentUploads-add-another-paystub", variant: "outline" }, getLocalizedString('ADD_ANOTHER_DOCUMENT'))),
                React.createElement(Button, { "data-testid": "DocumentUploads-submit", variant: "solid", onClick: onSubmit, disabled: !submittable }, getLocalizedString('SUBMIT'))))));
};
export default DocumentUploadsList;
